export enum KoddiAdTypeEnum {
  COBRAND = 'COBRAND'
}

export enum KoddiProductCodeEnum {
  RO = 'RO',
  RP = 'RP'
}
